import { PropsWithChildren } from 'react'

import styled from 'styled-components'

type BorderStatusBoxProps = {
  statusColor: string
}

export const PillBox = styled.div<PropsWithChildren<BorderStatusBoxProps>>`
  width: 6px;
  min-height: 100%;
  align-self: stretch;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  flex-shrink: 0;

  background-color: ${({ statusColor }) => statusColor};
`
